const actionConstants = {
    OPEN_MODAL: 'OPEN_EDIT_DOCUMENT_MODAL',
    CLOSE_MODAL: 'CLOSE_EDIT_DOCUMENT_MODAL',
};

export default actionConstants